import { useEffect, useState } from "react";
import {
  dieStatusAPI,
  supplierDieAPI,
  locationAPI,
  customerAPI,
  dieMasterAPI,
  DieTypeAPI,
  ToolingAPI,
} from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Model from "../../common/Model";
import EntityAddModal from "../../common/EntityAddModal/index";
import InputField from "../../common/InputField";
import { AnimatePresence, motion } from "framer-motion";
import {
  MdAttachFile,
  MdClose,
  MdOutlineDescription,
  MdOutlineSettings,
} from "react-icons/md";
import Button from "../../common/Button";
import { IoMdClose } from "react-icons/io";
import { BsSave2, BsSave2Fill } from "react-icons/bs";
import { FaPaperPlane } from "react-icons/fa";

const DieForm = ({
  initialData,
  onSubmit,
  onCancel,
  isEditing,
  isSaving = false,
}) => {
  const today = new Date().toISOString()?.split("T")[0];
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const [formData, setFormData] = useState({
    id: 0,
    dieNumber: "",
    dieDate: today,
    subDieNo: "",
    invoiceNo: "",
    profileName: "",
    orderWeight: "",
    currentWeight: "",
    seriesName: "",
    customer_Id: "",
    width: "",
    height: "",
    supplier_Id: "",
    status_Id: 1,
    location_Id: "",
    range: "",
    range_Per: "",
    die_Pdf: null,
    die_Image: null,
    created_By: userId,
    toolingSize_Id: "",
    die_Type_Id: "",
    no_Of_Cavity: "",
    hardness: "",
    area_Sqmm: "",
    perimeter: "",
    profileThickness: "",
  });
  const [errors, setErrors] = useState({});
  const [pdfFile, setPdfFile] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [dieTypeOptions, setDieTypeOptions] = useState([]);
  const [toolingSizeOptions, setToolingSizeOptions] = useState([]);
  const [attachedPdfName, setAttachedPdfName] = useState(null);
  const [modalType, setModalType] = useState(null);

  const loadDropdowns = async () => {
    try {
      const [customers, suppliers, statuses, locations, dieType, toolingSize] =
        await Promise.all([
          customerAPI.getAll(),
          supplierDieAPI.getAll(),
          dieStatusAPI.getAll(),
          locationAPI.getAll(),
          DieTypeAPI.getAll(),
          ToolingAPI.getAll(),
        ]);

      setCustomerOptions(
        customers.data.map((c) => ({
          value: c.customer_Id,
          label: c.name,
        })),
      );
      setSupplierOptions(
        suppliers.data.map((s) => ({
          value: s.supplier_Id,
          label: s.supplier_Name,
        })),
      );
      setStatusOptions(
        statuses.map((s) => ({ value: s.id, label: s.status_Name })),
      );
      if (!initialData && !formData.status_Id) {
        setFormData((prev) => ({ ...prev, status_Id: 1 }));
      }
      setLocationOptions(
        locations.data.map((l) => ({ value: l.location_Id, label: l.name })),
      );
      setDieTypeOptions(
        dieType.map((d) => ({ value: d.die_Type_Id, label: d.name })),
      );
      setToolingSizeOptions(
        toolingSize.map((t) => ({
          value: t.tooling_Size_Id,
          label: t.name,
        })),
      );
    } catch (err) {
      notify("Dropdown loading failed", "error");
    }
  };

  useEffect(() => {
    loadDropdowns();
  }, []);

  const handlePdfChange = (file) => {
    setPdfFile(file);
    setAttachedPdfName(file?.name || null);
  };

  useEffect(() => {
    if (initialData) {
      let w = "";
      let h = "";
      const whVal = initialData.widthHeight || initialData.width_Height || "";
      if (whVal) {
        const parts = whVal.split(/[xX*]/);
        w = parts[0]?.trim() || "";
        h = parts.length > 1 ? parts.slice(1).join("X")?.trim() : "";
      }

      setFormData({
        ...formData,
        ...initialData,
        width: w,
        height: h,
        range: initialData.to_Kg !== undefined ? initialData.to_Kg : (initialData.To_Kg !== undefined ? initialData.To_Kg : (initialData.range || initialData.die_Range || "")),
        range_Per: 0,
        die_Image: initialData.die_Image || null,
        die_Pdf: initialData.die_Pdf || null,
        dieDate: initialData.dieDate?.split("T")[0] || "",
        status_Id: initialData.status_Id || 1,
      });
      setImageFile(initialData.die_Image || null);
      setAttachedPdfName(initialData.die_Pdf?.split("/").pop() || null);
    } else {
      setFormData({
        id: 0,
        dieNumber: "",
        dieDate: today,
        subDieNo: "",
        invoiceNo: "",
        profileName: "",
        orderWeight: "",
        currentWeight: "",
        seriesName: "",
        customer_Id: "",
        width: "",
        height: "",
        supplier_Id: "",
        status_Id: "",
        location_Id: "",
        range: "",
        range_Per: "",
        die_Pdf: null,
        die_Image: null,
        created_By: userId,
        tooling_Size: "",
        die_Type_Id: "",
        no_Of_Cavity: "",
        hardness: "",
        area_Sqmm: "",
        perimeter: "",
        profileThickness: "",
      });
      setAttachedPdfName(null);
    }
  }, [initialData]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = (type) => {
    const formDataToSend = new FormData();

    formDataToSend.append("Id", formData.id);
    formDataToSend.append("DieNumber", formData.dieNumber);
    formDataToSend.append("DieDate", formData.dieDate);
    formDataToSend.append("SubDieNo", formData.subDieNo || "");
    formDataToSend.append("Invoice_No", formData.invoiceNo || "");
    formDataToSend.append("Profile_Name", formData.profileName || "");
    formDataToSend.append("Series_Name", formData.seriesName || "");
    formDataToSend.append("Customer_Id", formData.customer_Id || "");
    const whString = (formData.width || formData.height) ? `${formData.width || ""}X${formData.height || ""}` : "";
    formDataToSend.append("Width_Height", whString);
    formDataToSend.append("CurrentWeight", formData.currentWeight);
    formDataToSend.append("OrderWeight", formData.orderWeight);
    formDataToSend.append("Status_Id", formData.status_Id);
    formDataToSend.append("Supplier_Id", formData.supplier_Id);
    formDataToSend.append("Location_Id", formData.location_Id);
    formDataToSend.append("From_Kg", formData.orderWeight || 0);
    formDataToSend.append("To_Kg", formData.range || 0);
    formDataToSend.append("Range_Per", 0);
    formDataToSend.append("Tooling_Size", formData.toolingSize_Id || "");
    formDataToSend.append("Die_Type_Id", formData.die_Type_Id || "");
    formDataToSend.append("No_Of_Cavity", formData.no_Of_Cavity || "");
    formDataToSend.append("Hardness", formData.hardness || "");
    formDataToSend.append("Area_Sqmm", formData.area_Sqmm || "");
    formDataToSend.append("Perimeter", formData.perimeter || "");
    formDataToSend.append("Profile_Thickness", formData.profileThickness || 0);
    if (imageFile instanceof File) {
      formDataToSend.append("Die_Image", imageFile);
    } else if (formData.id === 0) {
      formDataToSend.append("Die_Image", null);
    }

    if (pdfFile instanceof File) {
      formDataToSend.append("Die_Pdf", pdfFile);
    }

    if (formData.id === 0) {
      formDataToSend.append("Created_By", formData.created_By);
    } else {
      formDataToSend.append("Modify_By", 1);
    }
    onSubmit(formDataToSend, type);
  };

  const optionMap = {
    customer: {
      setter: setCustomerOptions,
      field: "customer_Id",
    },
    supplier: {
      setter: setSupplierOptions,
      field: "supplier_Id",
    },
    status: {
      setter: setStatusOptions,
      field: "status_Id",
    },
    location: {
      setter: setLocationOptions,
      field: "location_Id",
    },
    dieType: {
      setter: setDieTypeOptions,
      field: "die_Type_Id",
    },
    toolingSize: {
      setter: setToolingSizeOptions,
      field: "tooling_Size_Id",
    },
  };

  const handleEntityAddSuccess = async (type) => {
    const { setter } = optionMap[type];

    try {
      let updatedData;

      switch (type) {
        case "customer":
          updatedData = await customerAPI.getAll();
          setter(
            updatedData.data.map((c) => ({
              value: c.customer_Id,
              label: c.name,
            })),
          );
          break;
        case "supplier":
          updatedData = await supplierDieAPI.getAll();
          setter(
            updatedData.data.map((s) => ({
              value: s.supplier_Id,
              label: s.supplier_Name,
            })),
          );
          break;
        case "status":
          updatedData = await dieStatusAPI.getAll();
          setter(
            updatedData.map((s) => ({
              value: s.id,
              label: s.status_Name,
            })),
          );
          break;
        case "location":
          updatedData = await locationAPI.getAll();
          setter(
            updatedData.data.map((l) => ({
              value: l.location_Id,
              label: l.name,
            })),
          );
          break;
        case "dieType":
          updatedData = await DieTypeAPI.getAll();
          setter(
            updatedData.map((l) => ({
              value: l.die_Type_Id,
              label: l.name,
            })),
          );
          break;
        case "toolingSize":
          updatedData = await ToolingAPI.getAll();
          setter(
            updatedData.map((l) => ({
              value: l.tooling_Size_Id,
              label: l.name,
            })),
          );
          break;
        default:
          return;
      }

      setModalType(null);
    } catch (err) {
      notify("Failed to refresh dropdown", "error");
    }
  };


  const onFileRemove = async (fileType, dieId) => {
    try {
      const apiCall =
        fileType === "image"
          ? dieMasterAPI.dieIMGDelete(dieId)
          : dieMasterAPI.diePDFDelete(dieId);

      const res = await apiCall;

      if (res.success) {
        notify(`${fileType.toUpperCase()} deleted successfully`, "success");
        if (fileType === "image") setImageFile(null);
        else setPdfFile(null);
      } else {
        notify(`Failed to delete ${fileType}`, "error");
      }
    } catch (error) {
      console.error(`Delete ${fileType} error:`, error);
      notify(`Something went wrong while deleting ${fileType}`, "error");
    }
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 z-[9999]">
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          className="bg-white rounded-2xl shadow-2xl w-full max-w-6xl max-h-[92vh] overflow-hidden flex flex-col"
        >
          <div className="bg-gradient-to-r from-primary to-blue-700 text-white px-6 py-4 flex justify-between items-center shadow-lg">
            <div className="flex items-center gap-3">
              <div className="bg-blue-500 p-2 rounded-lg">
                <MdOutlineSettings className="text-white text-xl animate-spin-slow" />
              </div>
              <h2 className="text-xl font-bold text-white tracking-wide">
                {isEditing ? "UPDATE DIE RECORD" : "CREATE NEW DIE RECORD"}
              </h2>
            </div>
            <button
              onClick={onCancel}
              className="hover:bg-white/20 p-2 rounded-full transition-colors"
            >
              <MdClose size={28} />
            </button>
          </div>

          <form
            className="overflow-y-auto p-6 bg-slate-50/50"
            onSubmit={(e) => {
              e.preventDefault();
              handleSave("close");
            }}
          >
            <div className="mb-8">
              <h3 className="text-sm font-bold text-slate-500 uppercase mb-4 flex items-center gap-2">
                <span className="w-1 h-4 bg-primary rounded-full"></span>{" "}
                General Information
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-5">
                <InputField
                  type="date"
                  label="Entry Date"
                  value={formData.dieDate}
                  onChange={(v) => handleChange("dieDate", v)}
                />
                <InputField
                  label="Die Number"
                  required
                  value={formData.dieNumber}
                  onChange={(v) => handleChange("dieNumber", v)}
                  placeholder="D-201"
                  error={errors.dieNumber}
                />
                <InputField
                  label="Sub Die No."
                  value={formData.subDieNo}
                  onChange={(v) => handleChange("subDieNo", v)}
                  placeholder="A"
                />
                <InputField
                  label="Invoice No."
                  value={formData.invoiceNo}
                  onChange={(v) => handleChange("invoiceNo", v)}
                  placeholder="INV-123"
                />
                <InputField
                  type="selectWithAdd"
                  label="Customer Name"
                  value={formData.customer_Id}
                  onChange={(s) => handleChange("customer_Id", s?.value)}
                  options={customerOptions}
                  onAddNewClick={() => setModalType("customer")}
                  placeholder="Customer Name"
                />
                <InputField
                  type="selectWithAdd"
                  label="Supplier"
                  value={formData.supplier_Id}
                  onChange={(s) => handleChange("supplier_Id", s?.value)}
                  options={supplierOptions}
                  onAddNewClick={() => setModalType("supplier")}
                  placeholder="Supplier Name"
                />
                <InputField
                  type="selectWithAdd"
                  label="Status"
                  value={formData.status_Id}
                  onChange={(s) => handleChange("status_Id", s?.value)}
                  options={statusOptions}
                  onAddNewClick={() => setModalType("status")}
                  placeholder="Status Name"
                />
                <InputField
                  type="selectWithAdd"
                  label="Location"
                  value={formData.location_Id}
                  onChange={(s) => handleChange("location_Id", s?.value)}
                  options={locationOptions}
                  onAddNewClick={() => setModalType("location")}
                  placeholder="Location Name"
                />
              </div>
            </div>

            <div className="mb-8">
              <h3 className="text-sm font-bold text-slate-500 uppercase mb-4 flex items-center gap-2">
                <span className="w-1 h-4 bg-primary rounded-full"></span>{" "}
                Technical Specifications
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-5">
                <InputField
                  label="Profile Name"
                  value={formData.profileName}
                  onChange={(v) => handleChange("profileName", v)}
                  placeholder="Window Section"
                />
                <InputField
                  label="Series Name"
                  value={formData.seriesName}
                  onChange={(v) => handleChange("seriesName", v)}
                  placeholder="Architectural"
                />
                <InputField
                  label="Order Weight"
                  required
                  unit="kg"
                  value={formData.orderWeight}
                  onChange={(v) => handleChange("orderWeight", v)}
                  placeholder="2.500"
                />
                <InputField
                  label="Current Weight"
                  unit="kg"
                  value={formData.currentWeight}
                  onChange={(v) => handleChange("currentWeight", v)}
                  placeholder="2.450"
                />

                <InputField
                  label="Profile Thickness"
                  value={formData.profileThickness}
                  onChange={(v) => handleChange("profileThickness", v)}
                  placeholder="0.00"
                />

                <InputField
                  label="Range Configuration"
                  unit="kg"
                  value={formData.range}
                  onChange={(v) => handleChange("range", v)}
                  placeholder="3.60"
                />

                <InputField
                  label="Width"
                  value={formData.width}
                  onChange={(v) => handleChange("width", v)}
                  placeholder="100"
                />
                <InputField
                  label="Height"
                  value={formData.height}
                  onChange={(v) => handleChange("height", v)}
                  placeholder="50"
                />
                <InputField
                  type="selectWithAdd"
                  label="Die Type"
                  value={formData.die_Type_Id}
                  options={dieTypeOptions}
                  onChange={(s) => handleChange("die_Type_Id", s?.value)}
                  onAddNewClick={() => setModalType("dieType")}
                  placeholder="Die Type Name"
                />
                <InputField
                  type="selectWithAdd"
                  label="Tooling Size"
                  value={formData.toolingSize_Id}
                  options={toolingSizeOptions}
                  onChange={(s) => handleChange("toolingSize_Id", s?.value)}
                  onAddNewClick={() => setModalType("toolingSize")}
                  placeholder="Tooling Size Name"
                />
                <InputField
                  label="No of Cavity"
                  value={formData.no_Of_Cavity}
                  onChange={(v) => handleChange("no_Of_Cavity", v)}
                />
                <InputField
                  label="Hardness"
                  value={formData.hardness}
                  onChange={(v) => handleChange("hardness", v)}
                />
                <InputField
                  label="Area (sq.mm)"
                  value={formData.area_Sqmm}
                  onChange={(v) => handleChange("area_Sqmm", v)}
                />
                <InputField
                  label="Perimeter"
                  value={formData.perimeter}
                  onChange={(v) => handleChange("perimeter", v)}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-blue-50/50 p-4 rounded-xl border border-blue-100">
              <div className="space-y-2">
                <div className="flex items-center gap-2 mb-1">
                  <MdAttachFile className="text-blue-600" />
                  <span className="text-sm font-bold text-slate-700 uppercase">
                    Documents
                  </span>
                </div>
                <InputField
                  type="pdf"
                  label="Technical PDF"
                  onChange={handlePdfChange}
                  accept=".pdf"
                  currentFileName={attachedPdfName}
                  idSuffix="die-pdf"
                  dieId={formData.id}
                  onFileRemove={onFileRemove}
                  fileUrl={initialData?.die_Pdf}
                />
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2 mb-1">
                  <MdAttachFile className="text-blue-600" />
                  <span className="text-sm font-bold text-slate-700 uppercase">
                    Gallery
                  </span>
                </div>
                <InputField
                  type="image"
                  label="Die Profile Image"
                  onChange={(file) => setImageFile(file)}
                  previewUrl={imageFile}
                  dieId={formData.id}
                  onFileRemove={onFileRemove}
                />
              </div>
            </div>

            <div className="flex flex-wrap justify-end gap-3 mt-8 pt-6 border-t border-slate-200">
              <Button
                text="Discard"
                className="flex-1 sm:flex-none bg-white hover:bg-slate-50 text-slate-600 border border-slate-300 px-5 py-2 rounded-xl font-bold transition-all flex items-center justify-center gap-2"
                icon={IoMdClose}
                onClick={onCancel}
              />

              <div className="flex gap-2 bg-slate-100 p-1 rounded-xl">
                <Button
                  text="Add Blank"
                  className="bg-white hover:bg-slate-50 text-slate-700 font-bold px-4 py-2 rounded-lg shadow-sm border border-slate-200 transition-all text-sm gap-2"
                  icon={BsSave2}
                  onClick={() => handleSave("blank")}
                  loading={isSaving}
                  disabled={isSaving}
                />
                <Button
                  text="Same Invoice"
                  className="bg-white hover:bg-slate-50 text-slate-700 font-bold px-4 py-2 rounded-lg shadow-sm border border-slate-200 transition-all text-sm gap-2"
                  icon={BsSave2Fill}
                  onClick={() => handleSave("sameInvoice")}
                  loading={isSaving}
                  disabled={isSaving}
                />
              </div>

              <Button
                text={isEditing ? "UPDATE RECORD" : "FINALIZE & SAVE"}
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold px-8 py-2.5 rounded-xl shadow-lg shadow-blue-200 transition-all flex items-center gap-2"
                icon={FaPaperPlane}
                onClick={() => handleSave("close")}
                loading={isSaving}
                disabled={isSaving}
              />
            </div>
          </form>

          <Model
            isOpen={!!modalType}
            onClose={() => setModalType(false)}
            name={`Add New ${modalType}`}
          >
            <EntityAddModal type={modalType} onClose={handleEntityAddSuccess} />
          </Model>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default DieForm;
